export const equalObjProps = (oldValue, newValue) => {
  for (const key in oldValue) {
    if (oldValue[key] !== newValue[key]) {
      return false;
    }
  }
  return true;
};
